import React from 'react';
import createMuiTheme, { ThemeOptions, Theme } from '@material-ui/core/styles/createTheme';
import { MuiThemeProvider } from '@material-ui/core/styles';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    status: {
      success: string;
    };
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    status?: {
      success?: string;
    };
  }
}

// key theme customizations
export const pdfThemeOptions: ThemeOptions = {
  // overrides of default props
  props: {
    MuiGrid: {
      alignItems: 'flex-start',
      spacing: 0,
    },
  },
};

// theme generated from the theme customisations above
// so the overrides can acces theme values
export const pdfTheme: Theme = createMuiTheme(pdfThemeOptions);

export const PdfTheme: React.FC = ({ children }) => (
  <MuiThemeProvider theme={pdfTheme}>{children}</MuiThemeProvider>
);
